<template>
    <v-dialog
    v-model="show"
    persistent
    width="550">
   
    <v-card>
    <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">{{state=='new'?'Add':'Modify'}} Expenses Account </span>
            <v-spacer/>
            <v-btn fab x-small elevation="1" color="warning"  @click="emitToParent('close')"><v-icon >mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-4 def-font">
              {{data}}
          </v-card-text>
          <v-card-actions>
              <v-btn small color="error" text @click="emitToParent('close')">
                Close
              </v-btn>
              <v-spacer/>
              <v-btn small color="success" text @click="emitToParent('ok')">
                  Ok
              </v-btn>
          </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
      show:{
          type: Boolean,
          default: false
      },
      state:{
          type: String,
          default: ""
      },
      data: {
            type: Object,
          default:()=>{}
      }
  },
  methods: {
   emitToParent (action) {
      this.$emit('DialogEvent', action)
    }
  }
}
</script>
